import React from 'react'
import { type CollectionsFormModeProps } from 'domains/collections/components/collections-form/utils/collectionsForm.types'
import { useCollectionsFormData } from 'domains/collections/components/collections-form/utils/collectionsFormData.hooks'
import { CollectionsFormContent } from 'domains/collections/components/collections-form/CollectionsFormContent'
import { LoadingPage } from 'gin-and-tonic/containers/loading-page/LoadingPage'
import { ErrorPage } from 'gin-and-tonic/containers/error-page/ErrorPage'
import { type CollectionTypeEnum } from 'domains/collections/api'

export interface CollectionsListProps extends CollectionsFormModeProps {
  goToCollectionList: () => void
  retailerId?: string
  collectionType: CollectionTypeEnum
}

export const CollectionsForm: React.FunctionComponent<CollectionsListProps> = props => {
  const { formData, formDataLoading, formDataError } = useCollectionsFormData(props)

  if (formDataLoading) {
    return <LoadingPage />
  }

  if (formDataError) {
    // TODO: add a refetch here
    return <ErrorPage action={() => null} />
  }

  return <CollectionsFormContent {...props} formData={formData} />
}
